import { Component, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent, FormatService } from 'tms-lib';

@Component({
  selector: 'app-product-renderer',
  templateUrl: './product-renderer.component.html',
  styleUrl: './product-renderer.component.scss',
})
export class ProductRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  protected readonly formatService = inject(FormatService);

  get productKey() {
    return this.params.value;
  }

  get productDescription() {
    return this.rowData[this.params.descriptionField];
  }

  get productType() {
    return this.rowData[this.params.productTypeField];
  }
}
